import { z } from 'zod';
import { textWithinLimit } from '@/shared/lib/validation';
import { requiredNumber } from '@/shared/lib/validation';

/** Проверяет данные операции с бонусными баллами */
export const bonusOperationSchema = z.object({
    amount: requiredNumber('Укажите количество баллов')
        .refine((value) => value !== null && value > 0, 'Количество баллов должно быть больше 0'),
    description: textWithinLimit(500, 'Комментарий не должен превышать 500 символов', { trim: true }),
});

export type BonusOperationFormValues = z.infer<typeof bonusOperationSchema>;

/** Полный набор начальных значений формы бонусной операции */
export const BONUS_OPERATION_FORM_DEFAULTS: BonusOperationFormValues = {
    amount: null,
    description: '',
};
